import { useContext } from "react";

import { useTranslation } from "react-i18next";

import AuthContext from "context/auth/authContext";
import { isAuthenticatorType } from "shared/functions";

import ContentFrame from "../ContentFrame";
import ChangePassword from "./ChangePassword";
import TwoFactorAuthentication from "./TwoFactorAuthentication";
import TwoFactorRecoveryCodes from "./TwoFactorRecoveryCodes";

const Security = () => {
    const { authType } = useContext(AuthContext);

    const { t } = useTranslation();

    return (
        <ContentFrame title={t("Security##security")}>
            <ChangePassword />
            <TwoFactorAuthentication />
            {isAuthenticatorType(authType) && <TwoFactorRecoveryCodes />}
        </ContentFrame>
    );
};

export default Security;
